import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const PostIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path
            d="M4,16 L20,16 L20,14 L4,14 L4,16 L4,16 Z M4,20 L16,20 L16,18 L4,18 L4,20 L4,20 Z M4,4 L4,12 L20,12 L20,4 L4,4 L4,4 Z"
            id="Shape"
        />
    </SvgIcon>
);

export default PostIcon;
